module.exports = __webpack_public_path__ + "assets/img/logo_accent.5151b989.png";